<div *nzModalTitle>
    <h4>Pay order # {{ order?.id }}</h4>
</div>
<h3 class="subhead">Payment</h3>

<p class="body2">Select the desired payment method</p>

<!-- TODO make reusable payment methods list component ? -->
<ng-container
    *ngIf="paymentMethods && paymentMethods.length; else noPaymentMethodTpl"
>
    <nz-radio-group
        [(ngModel)]="selectedPaymentMethodId"
        (ngModelChange)="onPaymentMethodChange()"
    >
        <label
            *ngFor="let paymentMethod of paymentMethods; index as i"
            nz-radio
            [nzValue]="paymentMethod.id"
            class="option-payment-method"
        >
            <span class="option-label">
                <svg
                    width="21"
                    height="16"
                    viewBox="0 0 21 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M19.0538 0H1.94555C0.871202 0 0 0.942586 0 2.10567V13.895C0 15.0574 0.871202 16 1.94555 16H19.0538C20.1281 16 20.9993 15.0574 20.9993 13.895V2.10567C21 0.942586 20.1288 0 19.0538 0Z"
                        fill="#36495D"
                    />
                    <path
                        d="M12.2633 11.4301H8.73547V4.57059H12.2633V11.4301Z"
                        fill="#F16522"
                    />
                    <path
                        d="M8.96013 7.99996C8.96013 9.3913 9.56242 10.6305 10.5 11.4293C9.81375 12.0133 8.94906 12.3621 8.00819 12.3621C5.78135 12.3621 3.97644 10.4086 3.97644 7.99926C3.97644 5.58996 5.78135 3.63645 8.00819 3.63645C8.94906 3.63645 9.81375 3.98517 10.5 4.56918C9.56242 5.36946 8.96013 6.60863 8.96013 7.99996Z"
                        fill="#E41B24"
                    />
                    <path
                        d="M17.0236 8.00067C17.0236 5.59137 15.2187 3.63786 12.9918 3.63786C12.051 3.63786 11.1863 3.98658 10.5 4.57058C11.4376 5.36946 12.0399 6.60863 12.0399 7.99996C12.0399 9.3913 11.4376 10.6305 10.5 11.4293C11.1856 12.0133 12.051 12.3621 12.9918 12.3621C15.2187 12.3628 17.0236 10.4093 17.0236 8.00067ZM16.6388 5.2969V5.43709H16.6909V5.46527H16.5574V5.43709H16.6095V5.2969H16.6388ZM16.8973 5.2969V5.46597H16.8563L16.8094 5.34973L16.7625 5.46597H16.7215V5.2969H16.7501V5.42441L16.7944 5.3138H16.8244L16.8686 5.42441V5.29619H16.8973V5.2969Z"
                        fill="#F89E1C"
                    />
                </svg>

                <span class="body2"
                    >&nbsp;{{ '****' + paymentMethod?.last4 }}</span
                >
            </span>
        </label>
    </nz-radio-group>
</ng-container>
<ng-template #noPaymentMethodTpl>
    <div style="padding: 20px">
        You don't have any payment methods, please add one.
    </div>
</ng-template>

<div style="margin-top: 20px; margin-bottom: 20px">
    <button
        nz-button
        nzType="default"
        nzShape="round"
        (click)="showAddPaymentMethod()"
        *ngIf="!isAddPaymentMethodVisible"
    >
        Add new Card
    </button>
</div>

<div class="add-paymeny-method-container" *ngIf="isAddPaymentMethodVisible">
    <add-stripe-payment-method></add-stripe-payment-method>
</div>

<div *nzModalFooter>
    <button
        nz-button
        style="width: 100%; margin-top: 14px"
        nzSize="default"
        nzType="primary"
        nzShape="round"
        *ngIf="selectedPaymentMethodId"
        (click)="onPayClickHandler()"
    >
        Pay
        {{ order.totalAmount | currency: 'CAD' }}
    </button>
</div>
